<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M29.06 11.56a1.5 1.5 0 00-2.12-2.12l-21.5 21.5a1.5 1.5 0 000 2.12l21.5 21.5a1.5 1.5 0 002.12-2.12L8.622 32l20.44-20.44zm25.5 0a1.5 1.5 0 00-2.12-2.12l-21.5 21.5a1.5 1.5 0 000 2.12l21.5 21.5a1.5 1.5 0 002.12-2.12L34.122 32l20.44-20.44z"/></svg>